/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Included_6Inputs */

const tr_landing_pricing_included_6 = /** @type {(inputs: Landing_Pricing_Included_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryeri API bağlantıları`)
};

const en_landing_pricing_included_6 = /** @type {(inputs: Landing_Pricing_Included_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace API connections`)
};

const de_landing_pricing_included_6 = /** @type {(inputs: Landing_Pricing_Included_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz-API-Verbindungen`)
};

const ru_landing_pricing_included_6 = /** @type {(inputs: Landing_Pricing_Included_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-подключения к маркетплейсам`)
};

/**
* | output |
* | --- |
* | "Marketplace API connections" |
*
* @param {Landing_Pricing_Included_6Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_included_6 = /** @type {((inputs?: Landing_Pricing_Included_6Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Included_6Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_included_6(inputs)
	if (locale === "de") return de_landing_pricing_included_6(inputs)
	if (locale === "ru") return ru_landing_pricing_included_6(inputs)
	return tr_landing_pricing_included_6(inputs)
});